import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { ResendPinComponent } from './resend-pin.component';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';



@NgModule({
  declarations: [ResendPinComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  providers: [
    SuccessMessageComponent
  ]
})
export class ResendPinModule { }
